import __request__ from "routing/request";
export function listStatuses(sort = "status", page = 1, per_page = 15, query, direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/statuses", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(Status, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/statuses", Status, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeDefault(requestOptions) {
  return __request__("DELETE", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/statuses/default", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(id, Status, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/statuses/${id}`, Status, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/statuses/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setDefault(id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/statuses/${id}/default`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
